<template>
	<main>
	<div ref="parentElm">
      <div class="pd-both">
        <div class="md-layout sort-order-xsmall-100">
          <div class="md-layout-item">
            <label for="sortOrder">Sort Order</label>
            <div class="inline-sort w-25 " @click="sorting(sortOrder)">
              <p v-text="sortOrder" class="sorter"></p>
              <font-awesome-icon class='small-icon m-left-5' icon="caret-up" v-if="sortOrder == 'Oldest First'"/>
              <font-awesome-icon class='small-icon m-left-5' icon="caret-down" v-if="sortOrder == 'Newest First'"/>
            </div>
          </div>
          <div class="md-layout-item">
            <md-field class="align-right create-community w-50">
            <md-select @md-closed="sorting(selectedSort)"  name="community" placeholder="Community" v-model="selectedCommunity" id="community" aria-label="Select community to filter">
                <md-option value="all">All</md-option>
                <md-option v-for="(singleCommunity) in allCommunities" v-bind:key="singleCommunity._id" :value="singleCommunity._id">{{ singleCommunity.name }}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <div class="pd-both">

       <!--  <label for="sortOrder">Sort Order</label>
        <div class="inline-sort" @click="sorting(sortOrder)">
          <p v-text="sortOrder" class="sorter"></p>
          <font-awesome-icon class='small-icon m-left-5' icon="caret-up" v-if="sortOrder == 'Oldest First'"/>
          <font-awesome-icon class='small-icon m-left-5' icon="caret-down" v-if="sortOrder == 'Newest First'"/>
        </div> -->
      </div>

    <div class="card-row pd-both w-100">
      <div class="md-layout-item md-xsmall-size-100">
        <!-- <md-field class="align-right create-community w-25">
          <md-select @md-closed="sorting(selectedSort)"  name="community" placeholder="Community" v-model="selectedCommunity" id="community">
              <md-option value="all">All</md-option>
              <md-option v-for="(singleCommunity) in allCommunities" v-bind:key="singleCommunity._id" :value="singleCommunity._id">{{ singleCommunity.name }}</md-option>
            </md-select>
        </md-field> -->
      </div>
    </div>
    <div v-if="this.asks.length <= 0">
      <md-empty-state
        md-label="No Asks Found"
        md-description="Please select another community.">
      </md-empty-state>
    </div>
    <div class="content-panel" @click.stop="unselectExpanded" id="infinite-list">
      <div class="inbox">
        <div v-for="(ask, index) in asks" @click.stop="swapExpanded(index)" :key="ask._id">
          <template v-if="index != selectedRow">
            <md-card>
              <md-ripple class="ask-content">
                <md-card-header class="positiveresponse-outer">
                  <router-link :to="`/incomplete-asks/${ask._id}/request`" class="remove-link">
                    <div class="ask-subject" :style="{backgroundColor:ask.communityId.customSettings.primaryColor, color:ask.communityId.customSettings.secondaryColor}">
                      <ul class="list-inline mb-0">
                        <li>{{$lodash.has(ask.communityId, 'name') ? ask.communityId.name + ': ' + (ask.request && ask.request.subject ? ask.request.subject : 'N/A') : (ask.request && ask.request.subject ? ask.request.subject : 'N/A')}}</li>
                        <li class="count" v-if="ask.request && ask.request.comments && ask.request.comments.length">{{ask.request.comments.length}}</li>
                      </ul>
                    </div>
                  </router-link>
                  <div :style="{backgroundColor:ask.communityId.customSettings.primaryColor, color:ask.communityId.customSettings.secondaryColor}" class="positiveresponse">0 / 0</div>
                </md-card-header>
                <md-card-content>
                  <div class="md-subhead">
                    <div class="row">
                      <div class="col-sm-6">
                        <ul class="list-unstyled mb-0">
                          <li v-if="ask.isClose">Status: Incomplete (Closed)</li>
                          <li v-else>Status: Incomplete</li>
                          <li>Received: {{ask.createdAt | momentDate }}</li>
                        </ul>
                      </div>
                      <div class="col-sm-6">
                        <ul class="list-unstyled pull-right mb-0">
                          <li><span v-if="ask.request.first || ask.request.last">Sender: {{ ask.request.first }} {{ ask.request.last }}</span></li>
                          <li><span v-if="ask.email">Email: {{ ask.email.toString() }}</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <p class="mt-10" v-html="ask.request && ask.request.text ? nl2br(ask.request.text.substring(0, 500)) : 'N/A'"></p>
                </md-card-content>
              </md-ripple>
            </md-card>
          </template>
          <template v-if="index == selectedRow">
            <md-card>
              <md-ripple class="ask-text-content">
                <md-card-header class="positiveresponse-outer">
                  <router-link :to="`/incomplete-asks/${ask._id}/request`" class="remove-link">
                    <div class="ask-subject"  :style="{backgroundColor:ask.communityId.customSettings.primaryColor, color:ask.communityId.customSettings.secondaryColor}">
                      <ul class="list-inline mb-0">
                        <li>{{$lodash.has(ask.communityId, 'name') ? ask.communityId.name + ': ' + (ask.request && ask.request.subject ? ask.request.subject : 'N/A') : (ask.request && ask.request.subject ? ask.request.subject : 'N/A')}}</li>
                        <li class="count" v-if="ask.request && ask.request.comments && ask.request.comments.length">{{ask.request.comments.length}}</li>
                      </ul>
                    </div>
                  </router-link>
                  <div :style="{backgroundColor:ask.communityId.customSettings.primaryColor, color:ask.communityId.customSettings.secondaryColor}" class="positiveresponse">0 / 0</div>
                </md-card-header>
                <md-card-content>
                  <div class="md-subhead">
                    <div class="row">
                      <div class="col-sm-6">
                        <ul class="list-unstyled mb-0">
                          <li v-if="ask.isClose">Status: Incomplete (Closed)</li>
                          <li v-else>Status: Incomplete</li>
                          <li>Received: {{ask.createdAt | momentDate }}</li>
                        </ul>
                      </div>
                      <div class="col-sm-6">
                        <ul class="list-unstyled pull-right mb-0">
                          <li><span v-if="ask.request.first || ask.request.last">Sender: {{ ask.request.first }} {{ ask.request.last }}</span></li>
                          <li><span v-if="ask.email">Email: {{ ask.email.toString() }}</span></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <p class="mt-10" v-html="ask.request && ask.request.text ? nl2br(ask.request.text.substring(0, 500)) : 'N/A'"></p>
                </md-card-content>
                <md-card-actions class="card-actions">
                  <md-button class="md-raised md-round md-accent" v-if="!ask.isClose" @click="doInteraction(ask._id)">Close</md-button>
                </md-card-actions>
              </md-ripple>
            </md-card>

          </template>
        </div>
      </div>
    </div>
    <md-button class="md-fab loadmore-button" v-on:click="loadMore()" v-if="skip + limit < count" aria-label="Load more">
      <md-tooltip md-direction="left">Load more</md-tooltip>
      <md-icon><font-awesome-icon icon="recycle"/></md-icon>
    </md-button>
  </div>
</main>
</template>
<script>
import API from "../services/API";
export default {
  name: "Inbox",
  props: ["view"],
  data() {
    return {
      asks: [],
      selectedRow: -1,
      sortOrder: "Oldest First",
      selectedSort: "",
      api: new API(),
      fullPage: true,
      skip: 0,
      limit: 25,
      count: 0,
      allCommunities: [],
      selectedCommunity: "",
      communityStyle: {
        backgroundColor: "white",
        color: "black"
      }
    };
  },
  watch: {
	$route: "loadData"
	// sortOrder: "sortAsks"
  },
  created() {
    //this.loadData();
    this.$on("Reload", () => {
      this.loadData();
    });
    this.getAllCommunity();
    //this.loadMore();
  },
  mounted() {
    //this.scroll();
    //this.width = this.$refs['parentElm'].clientWidth / 16 + 'rem';
  },
  methods: {
    randomScroll() {
      const vs = this.$refs['vs'];
      const panel = vs.scrollPanelElm;
      const x = Math.random() * panel.scrollWidth;
      const y = Math.random() * panel.scrollHeight;
      vs.scrollTo({
        x,
        y
      });
    },
    loadData: async function() {
      console.log('test');
		var sort = '-1';
        if (this.sortOrder.match(/Oldest First/i)) {
          sort = '1';
        }
		if (!this.$route.query.term) {
			this.sortOrder = "Oldest First";
			this.selectedCommunity = "";
		}
      	// Need to initialize the default value on route change
      	this.skip = 0;
      	this.limit = 25;
      	this.count = 0;
      	this.asks = [];
		let url = `asks/incomplete-request-list?limit=${this.limit}&skip=${this.skip}&sort=${sort}&community=${this.selectedCommunity}`;
		await this.api.get(url).then(asks => {
        	if (asks.data instanceof Object || asks.data instanceof Array) {
          		this.count = asks.data.count;
      			this.asks = asks.data.asks;
        	}
      	});
    },
    getAllCommunity: async function () {
      	await this.api.get(`communities/all`).then(communities => {
        	this.allCommunities = communities.data;
      	});
    },
    // sortAsks: async function() {
    //   console.log("Sort this now");
    //   this.asks.sort((a, b) => {
    //     return a.createdAt > b.createdAt
    //       ? this.sortOrder.match(/Oldest First/i)
    //         ? 1
    //         : -1
    //       : this.sortOrder.match(/Oldest First/i)
    //         ? -1
    //         : 1;
    //   });
    // },
    swapExpanded: function(i) {
      	this.selectedRow = i;
      	//event.stopPropagation();
    },
    unselectExpanded: function() {
      	this.selectedRow = -1;
    },
    sorting: async function(text) {
    	if (text.match(/Oldest First/i)) {
    		this.sortOrder = 'Newest First';
    	} else {
    		this.sortOrder = 'Oldest First';
      	}
      	// Selected sort order
      	this.selectedSort = text;
      	//console.log(this.selectedCommunity, this.selectedSort);
      	var sort = '1';
      	if (text.match(/Oldest First/i)) {
        	sort = '-1';
      	}
      	// Need to initialize the default value on route change
      	this.skip = 0;
      	this.limit = 25;
      	this.count = 0;
  		this.asks = [];

		let url = `asks/incomplete-request-list?limit=${this.limit}&skip=${this.skip}&sort=${sort}&community=${this.selectedCommunity}`;

  		await this.api.get(url).then(asks => {
	        if (asks.data instanceof Object || asks.data instanceof Array) {
	          	this.count = asks.data.count;
	          	this.asks = asks.data.asks;
	        }
      	});
    },
    scroll() {
    	var a = window.innerHeight + window.scrollY;
    	var b = document.body.offsetHeight;
         window.onscroll = ev => {
            if (Math.ceil(window.innerHeight + window.scrollY) + (b - a) >= document.body.offsetHeight) {
           		this.skip = this.skip + this.limit;
           		if (this.skip < this.count) {
    				this.loadMore();
    			}
  			}
         };
    },
    async loadMore() {
      	this.skip = this.skip + this.limit;
      	if (this.skip < this.count) {
        	var sort = '-1';
    		if (this.sortOrder.match(/Oldest First/i)) {
          		sort = '1';
        	}
        	await this.api.get(`asks/incomplete-request-list`, {params: { limit: this.limit, skip: this.skip, sort: sort, community: this.selectedCommunity }}).then(asks => {
        		if (asks.data instanceof Object || asks.data instanceof Array) {
	          		this.count = asks.data.count;
	          		this.asks = [...this.asks, ...asks.data.asks];
        		}
        	});
      	}
    },
    nl2br (str, replaceMode, isXhtml) {
      var breakTag = (isXhtml) ? '<br />' : '<br>';
      var replaceStr = (replaceMode) ? '$1' + breakTag : '$1' + breakTag + '$2';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr);
    },
    doInteraction: function(askId) {
			  this.$router.push({path: `/incomplete-asks/${askId}/request`, query: {action: 'close'}});
		}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/IncompleteRequestList.vue